import { render, staticRenderFns } from "./accounting-fill.vue?vue&type=template&id=2c49bafa&scoped=true&"
import script from "./accounting-fill.vue?vue&type=script&lang=js&"
export * from "./accounting-fill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49bafa",
  null
  
)

export default component.exports